import {Component, computed, inject, input} from '@angular/core';
import {Notification, NotificationService} from '@shared/notification/notification.service';
import {LucideAngularModule, XIcon} from 'lucide-angular';

@Component({
  selector: 'app-toast',
  imports: [
    LucideAngularModule
  ],
  styleUrl: './toast.component.scss',
  templateUrl: './toast.component.html'
})
export class ToastComponent {

  public readonly notification = input.required<Notification>();
  private readonly notificationService = inject(NotificationService);

  public readonly icons = {
    close: XIcon
  };

  public dismiss(): void {
    this.notificationService.remove(this.notification());
  }

}
